<template>
  <div class="mb-4">
    <div class="py-4  text-center">
      <h4 class="_theme_font_bold">
        <Spark />
        {{ botResponse?.component?.header || "Here's Some things you can do." }}
      </h4>
    </div>
    <div v-if="serviceButtons && serviceButtons.length">
      <div class=" start_up_buttons">
        <div v-for="(item, index) in serviceButtons" :key="index" class="bg-white shadow-sm start_up_button_card"
          @click="onPayloadButtonClick($event, item)">
          <div class="custom-payload-con d-flex align-items-center flex-column justify-content-center">
            <div :title="item.text" class=" cursor-pointer icon_container" :disabled="isWaitingForResponse">
              <em
                :class="['primaryicon-' + item.image, item.icon == 'primaryicon-Sales-Special' ? 'customfontsize' : '']"
                :style="{ color: chatThemeSettings?.borderColor || '#000' }" />

            </div>
            <p class="m-0 _theme_font_bold">
              {{ item.text }}
            </p>
          </div>
        </div>
        <div>
          <div @click="openTextUs()"
            class="d-flex align-items-center bg-white flex-column shadow-sm  start_up_button_card custom-payload-con  ">
            <!-- <TextUsIcon height="25" width="25" :theme-color="chatThemeSettings?.borderColor" /> -->
            <div class="icon_container">
              <em class="primaryicon-mobile" :style="{ color: chatThemeSettings?.borderColor || '#000' }" />
            </div>

            <span class="_theme_font_bold"> {{ customizedFlowNameForTextUs }} </span>
          </div>
        </div>
      </div>
    </div>

    <div v-if="showModal">
      <div id="viewDetailsModal" class="modal" :style="{ display: showModal ? 'block' : 'none' }"
        style="overflow: auto">
        <div class="modal-dialog">
          <div class="modal-content">
            <!-- Modal Header -->
            <div class="modal-header align-items-center">
              <h6 class="m-0 _theme_font_bold">Text Us</h6>
              <div>
                <button type="button" aria-label="Close" class="close" @click.prevent="showModal = false">
                  ×
                </button>
              </div>
            </div>
            <div class="p-3">
              <TextusForm />
            </div>
          </div>
        </div>
      </div>
      <div class="modal-backdrop show" />
    </div>
  </div>
</template>
<script>
import TextusForm from '../../TextusForm/TextusForm.vue';
import TvmStartUpButtons from '../../TvmStartUpButtons/TvmStartUpButtons.js';
import Spark from '../Icons/Spark.vue';

export default {
  mixins: [TvmStartUpButtons],
  data() {
    return {
      showModal: false,
      isTextUsEnabled: window.isTextUsEnabled,
    };
  },
  methods: {
    openTextUs() {
      this.showModal = true;
    }
  },
  components: {
    TextusForm,
    Spark
  },
}
</script>
<style>
@media (min-width: 1920px) and (max-width: 2399px) {
  .ask_ai .start_up_buttons :deep(p) {
    font-size: 16px;
  }
}

.start_up_buttons {
  gap: 15px;
  /* max-width: 1000px; */
  display: grid;
  grid-template-columns: repeat(5, 1fr);
}

.start_up_button_card {
  border-radius: 11px;
  padding: 20px 10px;
}

.start_up_button_card em {
  font-size: 26px;
}

.start_up_button_card:hover {
  cursor: pointer;
  /* transform: scale(1.1, 1.1);
  transition: all 0.5s ease-in; */
}

.text_us_button {
  /* border: 1px solid #878787; */
}

.custom-payload-con .icon_container {
  border: 1px solid #eee;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 10px 0;
}
</style>
